import { Form, Input, Select } from "antd";
import type { CreatePlantRequest } from "../types";

const TYPE_OPTIONS: { value: string; label: string }[] = [
	{ value: "DARAXT", label: "Daraxt" },
	{ value: "KO'CHAT", label: "Ko'chat" },
	{ value: "GUL", label: "Gul" },
];

interface PlantFormProps {
	form: ReturnType<typeof Form.useForm<CreatePlantRequest>>[0];
}

export function PlantForm({ form }: PlantFormProps) {
	return (
		<Form form={form} layout="vertical" requiredMark={false}>
			<Form.Item name="organizationId" hidden>
				<Input />
			</Form.Item>
			<div className="grid grid-cols-2 gap-4">
				<Form.Item
					name="name"
					label="Nomi"
					rules={[
						{ required: true, message: "Nomini kiriting" },
						{ max: 255, message: "Maksimum 255 ta belgi" },
					]}
				>
					<Input placeholder="Masalan: Chinor" size="middle" />
				</Form.Item>
				<Form.Item name="type" label="Turi" rules={[{ required: true, message: "Turini tanlang" }]}>
					<Select options={TYPE_OPTIONS} placeholder="Turini tanlang" />
				</Form.Item>
				<Form.Item
					name="description"
					label="Tavsifi"
					className="col-span-2"
					rules={[{ max: 2000, message: "Maksimum 2000 ta belgi" }]}
				>
					<Input.TextArea rows={3} placeholder="Ixtiyoriy tavsif" />
				</Form.Item>
			</div>
		</Form>
	);
}
